import React from 'react';
import { UserType } from '../../../../types/userType';
import PostReplyInput from './PostReplyInput';

interface ReplyInputFooterProps {
  currentUser: UserType | null;
  originalPostUsername: string;
  onReplyClick: () => void;
}

const ReplyInputFooter: React.FC<ReplyInputFooterProps> = ({
  currentUser,
  originalPostUsername,
  onReplyClick
}) => {
  if (!currentUser) {
    return null;
  }

  return (
    <div className="post-reply-input-container" onClick={onReplyClick}>
      <PostReplyInput
        content=""
        onContentChange={() => {}}
        currentUser={currentUser}
        originalPostUsername={originalPostUsername}
        placeholder={`Reply to ${originalPostUsername}...`}
        isClickable={true}
      />
    </div>
  );
};

export default ReplyInputFooter; 